import { trackEvent } from '@Services/analytics/tracking.service.ts';

export const reportActOnUboCenter = (uboCount: number): void => {
  trackEvent('Act on UBO center', { action: 'Owner list is complete', uboCount });
};

export const reportOnlyOwner = (value: boolean) => {
  trackEvent('Act on UBO center', {
    action: value ? 'IM THE ONLY OWNER' : 'IM NOT THE ONLY OWNER',
  });
};

export const reportActOnSlider = (value: number | null) => {
  trackEvent('Act on UBO center', {
    owner: value,
  });
};
